import { GeneralStatus } from "./GeneralStatus";

export class GeneralStatusFunctions {
    static carregat(generalStatus: GeneralStatus): boolean {
        if (GeneralStatus.done == generalStatus)
            return true;
        if (GeneralStatus.loaded == generalStatus)
            return true;
        if (GeneralStatus.loadedunloaded == generalStatus)
            return true;
        if (GeneralStatus.unloaded == generalStatus)
            return true;
        return false;
    }
}
